<script>
    export let image1;
    export let image2;
</script>

<div class="front-back-img-container">
    <img src={image1.frontImgPath} class:horizontal={image1.isHorizontal} alt="" />
    <img src={image2.backImgPath} alt="" />
</div>

<style>
    .front-back-img-container {
        display: flex;
        width: 75%;
        justify-content: space-evenly;
    }
    img {
        width: 25vw;
        height: intrinsic;
        border-radius: 8%;
    }
    .horizontal {
        transform: rotate(90deg);
    }
</style>